var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 1.03125C11.6211 1.03125 0.78125 11.8711 0.78125 25.25C0.78125 38.6289 11.6211 49.4688 25 49.4688C38.3789 49.4688 49.2188 38.6289 49.2188 25.25C49.2188 11.8711 38.3789 1.03125 25 1.03125Z",
    fill: "#959CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6406 24.8281C20.4062 24.5938 20.0312 24.5938 19.8438 24.8281L18.7656 25.8594C18.5312 26.0938 18.5312 26.4688 18.7656 26.6562L23.0312 30.9688C23.2188 31.2031 23.5938 31.2031 23.8281 30.9688L31.8906 22.9531C32.125 22.7188 32.125 22.3438 31.8906 22.1562L30.8594 21.0781C30.625 20.8438 30.2969 20.8438 30.0625 21.0781L23.4531 27.6406L20.6406 24.8281ZM34.8438 17.9375L25.8438 14.1875C25.5625 14.0938 25.2812 14.0469 25 14.0469C24.6719 14.0469 24.3906 14.0938 24.1094 14.1875L15.1094 17.9375C14.2656 18.3125 13.75 19.1094 13.75 20C13.75 29.3281 19.0938 35.75 24.1094 37.8594C24.6719 38.0938 25.2812 38.0938 25.8438 37.8594C29.875 36.1719 36.25 30.4062 36.25 20C36.25 19.1094 35.6875 18.3125 34.8438 17.9375ZM25 35.75C20.4062 33.875 16 27.9688 16 20L25 16.25L34 20C34 28.1562 29.3594 33.9219 25 35.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.695166c9.svg";
export { ForwardRef as ReactComponent };